import { render, staticRenderFns } from "./favorites-state-provider.vue?vue&type=template&id=44472e65&"
import script from "./favorites-state-provider.vue?vue&type=script&lang=js&"
export * from "./favorites-state-provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports